import * as React from "react";

export function Tooltip({ children }: { children: React.ReactNode }) {
  const [visible, setVisible] = React.useState(false);

  // Espera que children sean [<TooltipTrigger />, <TooltipContent />]
  const trigger = React.Children.toArray(children).find(
    (child: any) => child.type && child.type.displayName === 'TooltipTrigger'
  );
  const content = React.Children.toArray(children).find(
    (child: any) => child.type && child.type.displayName === 'TooltipContent'
  );

  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      {trigger && React.cloneElement(trigger as React.ReactElement, {
        onMouseEnter: () => setVisible(true),
        onMouseLeave: () => setVisible(false),
      })}
      {content && visible && React.cloneElement(content as React.ReactElement)}
    </span>
  );
}
Tooltip.displayName = 'Tooltip';

export function TooltipProvider({ children, delayDuration }: { children: React.ReactNode; delayDuration?: number }) {
  return <>{children}</>;
}

export function TooltipTrigger({ children, ...props }: { children: React.ReactNode; onMouseEnter?: () => void; onMouseLeave?: () => void }) {
  return <span {...props}>{children}</span>;
}
TooltipTrigger.displayName = 'TooltipTrigger';

export function TooltipContent({ children, ...props }: any) {
  return (
    <span
      {...props}
      style={{
        position: 'absolute',
        zIndex: 100,
        background: '#dc2626',
        color: '#fff',
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '13px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
        left: '50%',
        top: '100%',
        transform: 'translateX(-50%)',
        whiteSpace: 'pre-line', // Permite saltos de línea
        minWidth: '180px',
        maxWidth: '320px',
        wordBreak: 'break-word',
        textAlign: 'center',
      }}
    >
      {children}
    </span>
  );
}
TooltipContent.displayName = 'TooltipContent';
